import { apiRequest, helpdeskServiceUpdate, helpdeskServiceDetail } from "../../../../services/adapters/base";

class UpdateRepository {
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      helpdeskServiceUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      helpdeskServiceDetail,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
